/**
 * Status calculation utilities for services and work orders
 */
import { normalizeProgress } from './formatUtils';

export const getProgressStatus = (service) => {
	const progressField = service.percentageComplete ?? 0;
	const progress = normalizeProgress(progressField);
	const percentageOverTime = service.percentageOverTime || 0;

	if (
		service.status === "Complete" ||
		service.status === "C" ||
		progress >= 100
	) {
		if (percentageOverTime > 10) return "severe-over";
		if (percentageOverTime > 5) return "moderate-over";
		if (percentageOverTime > 0 && percentageOverTime <= 5) return "slight-over";
		return "ontrack";
	}

	if (!service.scheduledDate || progress === 0) {
		return "ontrack";
	}

	if (progress > 0 && progress < 100) {
		if (percentageOverTime > 10) return "severe-over";
		if (percentageOverTime > 5) return "moderate-over";
		if (percentageOverTime > 0 && percentageOverTime <= 5) return "slight-over";
		return "ontrack";
	}

	return "ontrack";
};

export const getWorkOrderStatus = (workOrderData) => {
	if (!workOrderData) return "ontrack";

	const percentageOverTime = workOrderData.percentageOverTime || 0;
	const progress = normalizeProgress(workOrderData.percentageComplete ?? 0);

	if (progress >= 100) {
		if (percentageOverTime > 10) return "severe-over";
		if (percentageOverTime > 5) return "moderate-over";
		if (percentageOverTime > 0 && percentageOverTime <= 5) return "slight-over";
		return "ontrack";
	}

	if (percentageOverTime > 10) return "severe-over";
	if (percentageOverTime > 5) return "moderate-over";
	if (percentageOverTime > 0 && percentageOverTime <= 5) return "slight-over";
	
	return "ontrack";
};